import which from "which";
/**
 * Check if nala is installed
 */
export function hasNala() {
    return which.sync("nala", { nothrow: true }) !== null;
}
/**
 * Check if apt-fast is installed
 */
export function hasAptFast() {
    return which.sync("apt-fast", { nothrow: true }) !== null;
}
/**
 * Check if apt is installed
 */
export function hasApt() {
    return which.sync("apt", { nothrow: true }) !== null;
}
/**
 * Check if apt-get is installed
 */
export function hasAptGet() {
    return which.sync("apt-get", { nothrow: true }) !== null;
}
/**
 * Get the apt command to use
 * If nala is installed, use that, otherwise use apt-get
 */
export function getApt() {
    if (hasNala()) {
        return "nala";
    }
    else if (hasAptFast()) {
        return "apt-fast";
        // } else if (hasApt()) {
        //   return "apt"
    }
    else if (hasAptGet()) {
        return "apt-get";
    }
    else {
        throw new Error("No apt command found");
    }
}
//# sourceMappingURL=data:application/json;base64,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